<template>
  <div>
    <div style="padding: 15px 50px 15px 30px" class="blue_holder mb-4">
      <h4 class="mb-4">Attendance Status</h4>
      <div class="flex flex-wrap justify-between">
        <template
          v-if="
            ['offline_one_2_one', 'online_one_2_one'].includes(
              course_details.courseStructure
                .course_type.type
            )
          "
        >
        <div>
        <label class="font-bold block w-full mb-2">Student</label>
          <vs-row>
          <vs-radio 
            :vs-value="true" 
            @change="attendanceAssign('single')" 
            vs-name="StudentPresent" 
            v-model="clientList.attendance" 
            class="mr-2" 
            :disabled="checkCurrentDay"
            >Present</vs-radio>
          <vs-radio
            :vs-value="false"
            @change="attendanceAssign('single')"
            class="mr-2"
            v-model="clientList.attendance"
            :disabled="checkCurrentDay"
            vs-name="StudentAbsent"
            >Absent</vs-radio>
          <span
          v-if="clientList.attendance == true"
            class="material-icons-outlined edit cursor-pointer"
            @click="attendance_box=true"
            >edit</span
          >
          <div v-if="clientList.delay_in_minutes">
            <p
              class="cstm_badge warning mr-1"
              v-if="clientList.attendance == true && clientList.delay_in_minutes>0"
            >
            {{clientList.delay_in_minutes}} min delay
            </p>
            
          </div>
          </vs-row>
          <div v-if="attendance_box == true && clientList.attendance == true">
            <vs-row>
              <vs-input
              placeholder="Delay in min"
              v-model="clientList.delay_in_minutes"
            />
            <span
              class="material-icons-outlined cursor-pointer"
              style="color:green"
              @click="attendanceAssign('single')"
              >check</span
            >
            </vs-row>
           
          </div>
        </div>
          <div>
            <label class="font-bold block w-full mb-2">Teacher</label>
            <vs-radio
              v-model="TeacherList.attendance"
              @change="markTeacher('single')"
              :vs-value="true"  
              class="mr-2"
              :disabled="checkCurrentDay"
              vs-name="TeacherPresent"
              >Present</vs-radio
            >
            <vs-radio
              v-model="TeacherList.attendance"
              @change="markTeacher('single')"
              :vs-value="false"
              :disabled="checkCurrentDay"
              vs-name="TeacherAbsent"
              >Absent</vs-radio
            >
          </div>
        </template>
        <template v-else>
          <div class="select_dropdown_holder">
            <label class="pr-2">Students</label>
            <div class="relative" v-click-outside="outsideDropdown">
              <div class="select_div" @click="closeDropdown(clientList)">
                <span>All Students</span>
                <span
                  class="material-icons"
                  :class="[list_dropdown ? 'rotate' : '']"
                  >expand_more</span
                >
              </div>
              <div
                class="dropdown_select vertical_scrollbar"
                :class="[showDropdown ? 'show' : '']"
                @scroll="detectsScrollLength()"
                ref="element"
              >
                <div
                  class="each_data w-full"
                  v-for="(eachStudent, index) in clientList"
                  :key="index"
                >
                  <div class="flex flex-wrap justify-between items-center w-full">
                    <div class="inline-flex items-center">
                      <div class="relative">
                        <img
                          class="rounded-full shadow-md block"
                          v-if="eachStudent.picture"
                          :src="eachStudent.picture"
                          height="36"
                          width="36"
                        />
                        <span
                          v-else
                          class="material-icons"
                          style="font-size: 36px"
                          >account_circle</span
                        >
                        <span :style="[eachStudent.attendance ? {'background':'#5FBF82'} : eachStudent.attendance == false ?{'background':'#F15D5F'} : {'background':'transparent'}]" class="status">
                          <span class="material-icons-outlined">
                            {{eachStudent.attendance ? 'check' : eachStudent.attendance == false ? 'clear' : ''}}</span>
                        </span>
                      </div>
                      <span class="pl-2"
                        >{{ eachStudent.first_name }}
                        {{ eachStudent.last_name }}</span
                      >
                    </div>
                    <div>
                      <div class="flex flex-wrap justify-between items-center">
                        <div class="inline-flex">
                          <vs-radio class="mx-1" :vs-name="index" :vs-value="false" v-model="eachStudent.attendance" :disabled="checkCurrentDay"
                            >Absent</vs-radio
                          >
                          <vs-radio class="mx-1" :vs-name="index" :vs-value="true" v-model="eachStudent.attendance" :disabled="checkCurrentDay"
                            >Present</vs-radio
                          >

                        </div>
                        <span
                        v-if="eachStudent.attendance"
                          class="material-icons-outlined edit"
                          @click="edit_time(index)"
                          >edit</span
                        >

                        <div>
                          <p
                            class="cstm_badge warning mr-1"
                            v-if="eachStudent.attendance == true && active_el !== index && eachStudent.delay_in_minutes>0"
                          >
                            {{ eachStudent.delay_in_minutes }} min delay
                          </p>
                          <div class="delay_input_holder" v-if="active_el == index" :class="{ active: active_el == index }">
                            <vs-input
                              placeholder="Delay in min"
                              v-model="eachStudent.delay_in_minutes"
                            />
                            <span
                              class="material-icons-outlined delete"
                              @click="attendanceAssign('multiple')"
                              >check</span
                            >
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="select_dropdown_holder">
            <label class="pr-2">Teachers</label>
            <div class="relative" v-click-outside="outsideDropdownTeacher">
              <div class="select_div" @click="closeDropdownTeacher(TeacherList)">
                <span>All Teachers</span>
                <span
                  class="material-icons"
                  :class="[list_dropdown ? 'rotate' : '']"
                  >expand_more</span
                >
              </div>
              <div
                class="dropdown_select teacher_dropdown vertical_scrollbar"
                :class="[showDropdownTeacher ? 'show' : '']"
                @scroll="detectsScrollLength()"
                ref="element"
              >
                <div
                  class="each_data w-full"
                  v-for="(eachTeacher, index) in TeacherList"
                  :key="index"
                >
                  <div class="flex flex-wrap justify-between items-center w-full">
                    <div class="inline-flex items-center">
                      <div class="relative">
                        <img
                          class="rounded-full shadow-md block"
                          v-if="eachTeacher.picture"
                          :src="eachTeacher.picture"
                          height="36"
                          width="36"
                        />
                        <span
                          v-else
                          class="material-icons"
                          style="font-size: 36px"
                          >account_circle</span
                        >
                        <span :style="[eachTeacher.attendance ? {'background':'#5FBF82'} : eachTeacher.attendance == false ?{'background':'#F15D5F'} : {'background':'transparent'}]" class="status">
                          <span class="material-icons-outlined">
                            {{eachTeacher.attendance ? 'check' : eachTeacher.attendance == false ? 'clear' : ''}}</span>
                        </span>
                      </div>
                      <span class="pl-2"
                        >{{ eachTeacher.first_name }}
                        {{ eachTeacher.last_name }}</span
                      >
                    </div>
                    <div>
                      <div class="inline-flex flex-wrap items-center">
                        <div class="inline-flex">
                        <vs-radio class="mx-1" :vs-name="index" :vs-value="true" v-model="eachTeacher.attendance" :disabled="checkCurrentDay" @change="markTeacher('multiple')"
                          >Present</vs-radio
                        >
                        <vs-radio class="mx-1" :vs-name="index" :vs-value="false" v-model="eachTeacher.attendance" :disabled="checkCurrentDay" @change="markTeacher('multiple')"
                          >Absent</vs-radio
                        >
                        </div>
                      </div>
                   </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div style="padding: 15px 30px" v-if="attendance_teacher == '1'">
      <h4 class="mb-4">Attendance Billing</h4>
      <div class="py-2">
        <vs-radio v-model="billing_radio" vs-value="1"
          >Notice Given (Not Billable)</vs-radio
        >
      </div>
      <div class="flex justify-between items-center py-2">
        <vs-radio v-model="billing_radio" vs-value="2"
          >Absent is Billable</vs-radio
        >
        <div class="inline-flex items-center" v-if="billing_radio == '2'">
          <label class="pr-2">Price</label>
          <div class="icon_input_holder">
            <svg
              width="12"
              height="13"
              viewBox="0 0 12 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M2.574 12.766V4.738C2.574 3.838 2.76 3.058 3.132 2.398C3.516 1.726 4.08 1.21 4.824 0.85C5.58 0.478 6.498 0.291999 7.578 0.291999C8.31 0.291999 8.97 0.37 9.558 0.526C10.158 0.669999 10.698 0.909999 11.178 1.246L10.692 2.344C10.26 2.032 9.768 1.81 9.216 1.678C8.676 1.546 8.094 1.48 7.47 1.48C6.27 1.48 5.37 1.762 4.77 2.326C4.182 2.89 3.888 3.694 3.888 4.738V12.766H2.574ZM0.54 13V11.848H10.944V13H0.54ZM0.54 7.15V6.25H8.874V7.15H0.54Z"
                fill="black"
              />
            </svg>
            <input v-model="price" />
          </div>
        </div>
      </div>
      <div class="py-2">
        <vs-radio v-model="billing_radio" vs-value="3"
          >Bill & Give Make-up credit</vs-radio
        >
      </div>
    </div>

    <div style="padding: 15px 30px" class="blue_holder mb-4">
      <h4 class="mb-4">Schedule</h4>
      <div class="flex flex-wrap justify-between items-center">
        <p>
          {{
            eachEventInfo.extendedProps.course.schedule_from_time.slice(0, -3)
          }}-{{
            eachEventInfo.extendedProps.course.schedule_to_time.slice(0, -3)
          }}
        </p>
        <div class="inline-flex">
          <vs-button
            class="mr-2"
            type="border"
            color="danger"
            @click="cancelAlert"
            :disabled="checkReshedule"
            >Cancel</vs-button
          >
          <vs-button @click="checkRescheduleStatus" :disabled="checkReshedule">Reschedule</vs-button>
        </div>
      </div>
    </div>
    <div style="padding: 15px 30px;" class="blue_holder mb-4" v-if="resheduleCalender">
      <!-- <div class="update_header p-4">
            <div class="inline-flex items-center">
              <h6 class="pr-4">Updated Date</h6>
              <div class="input-group">
                <flat-pickr
                  v-model="date"
                  :config="config"
                  class="form-control"
                  placeholder="Select date"
                  name="date"/>
                <div class="input-group-append">
                  <button>
                    <span class="material-icons">event</span>
                  </button>
                </div>
              </div>
            </div>
            <vs-button>Save</vs-button>
          </div> -->
      <div>
        You are rescheduling lesson from
        {{
          eachEventInfo.extendedProps.course.schedule_date
            | moment("Do, MMMM  YYYY")
        }}
        {{
          eachEventInfo.extendedProps.course.schedule_from_time.slice(0, -3)
            | OnlytimeFormatLocalization
        }}-{{
          eachEventInfo.extendedProps.course.schedule_to_time.slice(0, -3)
            | OnlytimeFormatLocalization
        }}
      </div>
      <vs-row>
        <vs-col vs-lg="6" vs-sm="12" class="p-1">
          <div class="overflow_auto_flatpickr">
            <flat-pickr
              @input="fetchTimeByDate"
              class="w-full mb-2"
              v-model="schedule_start_date"
              :config="config"
            ></flat-pickr>
          </div>
        </vs-col>
        <vs-col
          vs-lg="6"
          vs-sm="12"
          class="px-4 py-1"
          v-if="availabilityTime.length > 0"
        >
          <h5 class="mb-4">Choose your available time slot</h5>
          <div style="border-right: none" class="time_zone_holder">
            <template v-for="(eachtime, index) in availabilityTime">
              <vs-radio
                class="mr-2 mb-2"
                :disabled="eachtime.status == 'Unavailable'"
                :key="index"
                v-model="timeSlot"
                vs-name="timezone"
                :vs-value="eachtime"
              >
                <div class="bg-grey">
                  {{ eachtime.from_time.slice(0, -3) }} -
                  {{ eachtime.to_time.slice(0, -3) }}
                </div>
              </vs-radio>
            </template>
          </div>
          <vs-button type="border" color="danger" class="m-1" @click="resheduleCalender=false">Cancel</vs-button>
          <vs-button @click="confirmReschedule" class="m-1">Confirm Reschedule</vs-button>
        </vs-col>
        <vs-col
          vs-lg="6"
          vs-sm="12"
          class="flex flex-col justify-center items-center px-4 py-1"
          v-if="availabilityTime.length == 0"
        >
          <p style="opacity: 0.7">No dates selected yet</p>
        </vs-col>
      </vs-row>
      <!-- <div class="time_zone_holder p-4 pb-0 mb-4">
            <h6 class="mb-4">Available Time Slot</h6>
            <vs-radio v-model="available_time" vs-value="1" class="mr-2 mb-2">
              <div class="bg-grey">
                09:00-09:30
              </div>
            </vs-radio>
            <vs-radio v-model="available_time" vs-value="2" class="mr-2 mb-2">
              <div class="bg-grey">
                09:30-10:30
              </div>
            </vs-radio>
          </div> -->
    </div>
    <div style="padding: 15px 30px;" class="blue_holder">
      <div class="time_zone_holder">
        <h6 class="mb-6">Your Previous reschedule</h6>
        <ol style="list-style-type: auto;" class="timeline_ul_holder">
          <template v-for="(reshedule, index) in reschedulesList">
            <li :key="index">
              {{reshedule.user.first_name}} {{reshedule.user.last_name}} changed from {{ reshedule.schedule_from_time.slice(0, -3) }} -
              {{ reshedule.schedule_to_time.slice(0, -3) }} of
              {{ reshedule.schedule_from_date }} to
              {{ reshedule.changed_from_time.slice(0, -3) }} -
              {{ reshedule.schedule_to_time.slice(0, -3) }} of
              {{ reshedule.changed_from_date }}
            </li>
          </template>
        </ol>
      </div>
    </div>
  </div>
</template>
<script>
import {
  cancelSchedulerApi,
  getStudentListForSchedule,
  getTeacherListForSchedule
} from '@/api/schedulerApi'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import {
  fetchResheduleLog,
  fetchResheduleSlot,
  markAttendence,
  confirmRescheduleApi,
  markAttendenceTeacher
} from '@/api/calenderAction.js'
export default {
  components: {
    flatPickr
  },
  created () {
    const role_permission = localStorage.getItem('role_permission')
    if (role_permission === '1') {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
    }
  },
  computed :{
    checkReshedule () {
      if (this.schoolAdmin) {
        return false
      } else if (this.$moment().diff(this.eachEventInfo.start, 'minutes') <= 0) return false
      else return true
    },
    checkCurrentDay () {
      return !(this.$moment().diff(this.eachEventInfo.start, 'minutes') >= 0)
    }
  },
  mounted () {
    this.fetchResheduleLog()
    this.fetchUserClient()
    this.fetchTeacherList()
  },
  props: {
    eachEventInfo: {
      default: {}
    },
    course_details: {
      default: {}
    }
  },
  data () {
    return {
      attendance_teacher: null,
      remainingReschedule: 0,
      clientListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      clientList: [],
      TeacherListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      TeacherList: [],
      reschedulesList: [],
      showDropdown: false,
      showDropdownTeacher: false,
      list_dropdown: false,
      resheduleCalender: false,
      attendance: false,
      delay_in_minutes: null,
      config: {
        inline: true
      },
      active_el: null,
      attendance_box:false,
      timeSlot: null,
      availabilityTime: [],
      available_time: '',
      schedule_start_date: null,
      attendance_radio: null,
      customer_id: localStorage.getItem('customer_id')
    }
  },
  methods: {
    outsideDropdown () {
      this.showDropdown = false
    },
    outsideDropdownTeacher () {
      this.showDropdownTeacher = false
    },
    async markTeacher (type) {
      const payload = {
        course_id: this.eachEventInfo.extendedProps.course.course_id,
        schedule_id: this.eachEventInfo.extendedProps.course.id,
        unique_id: this.eachEventInfo.extendedProps.course.unique_id,
        attendance_date: this.$moment(
          this.eachEventInfo.extendedProps.course.schedule_date
        ).format('YYYY-MM-DD'),

        teachers:
          type === 'multiple'
            ? this.TeacherList.map((ele) => {
              return {
                attendance: ele.attendance,
                teacher_id: ele.id
              }
            })
            : [
              {
                attendance: this.TeacherList.attendance,
                teacher_id: this.TeacherList.id
              }
            ]
      }

      await markAttendenceTeacher(this.customer_id, payload)
      this.showSuccessMessage(
        'Success',
        'Teacher marked Successfully',
        'success'
      )
    },
    closeDropdown () {
      this.showDropdown = !this.showDropdown
      // if (!this.showDropdown) {
      //   this.attendanceAssign('multiple')
      // }
    },
    checkRescheduleStatus () {
      if (this.remainingReschedule === 0) {
        this.showSuccessMessage(
          'Error',
          'You have reached the maximum number of reschedules for this course',
          'danger'
        )
      } else {
        this.resheduleCalender = true
      }
    },
    closeDropdownTeacher () {
      this.showDropdownTeacher = !this.showDropdownTeacher
      if (!this.showDropdownTeacher) {
        this.markTeacher('multiple')
      }
    },
    edit_time (index) {
      if (!this.checkCurrentDay) {
        this.active_el = index
      } else {
        this.showSuccessMessage(
          'Warning',
          'You can not edit the future attendance',
          'warning'
        )
      }

    },
    removeDelay (delayIndex) {
      console.log('delayIndex', delayIndex)
      this.clientList = this.clientList.map((el, index) => {
        if (index === delayIndex) {
          el.delay_in_minutes = null
        }
        return el
      })
      console.log(this.clientList)
      this.active_el = null
    },
    async loadMoreClient () {
      this.clientListMeta.current_page = this.clientListMeta.current_page + 1
      const payload = {
        schedule_id: this.eachEventInfo.extendedProps.course.id
      }
      try {
        const res = await getStudentListForSchedule(
          payload,
          localStorage.getItem('customer_id')
        )
        this.clientList.push(...res.data.data.students)
        this.clientListMeta = res.data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    async detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight
      ) {
        this.loadMoreClient()
      }
    },
    async fetchUserClient () {
      const payload = {
        schedule_id: this.eachEventInfo.extendedProps.course.id
      }
      getStudentListForSchedule(payload, localStorage.getItem('customer_id'))
        .then((res) => {
          this.clientList = res.data.data.students
          this.clientListMeta = res.data.data.meta
        })
        .catch((e) => {
          console.log(e)
        })
    },
    async fetchTeacherList () {
      const payload = {
        schedule_date: this.$moment(
          this.eachEventInfo.extendedProps.course.schedule_date
        ).format('YYYY-MM-DD'),
        course_id: this.eachEventInfo.extendedProps.course.course_id
      }
      getTeacherListForSchedule(payload, localStorage.getItem('customer_id'))
        .then((res) => {
          this.TeacherList = res.data.data.teachers
          this.TeacherListMeta = res.data.data.meta
        })
        .catch((e) => {
          console.log(e)
        })
    },
    async confirmReschedule () {
      const payload = {
        course_id: this.eachEventInfo.extendedProps.course.course_id,
        schedule_id: this.eachEventInfo.extendedProps.course.id,
        changed_from_date: this.schedule_start_date,
        changed_from_time: this.timeSlot.from_time,
        changed_to_time: this.timeSlot.to_time
      }
      await confirmRescheduleApi(this.customer_id, payload)

      this.showSuccessMessage(
        'Success',
        'Course resheduled Successfully',
        'success'
      )
      this.fetchResheduleLog()
      this.$emit('closeCalendarAttendance', true)
    },
    cancelAlert () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to cancel this schedule?',
        accept: this.cancelReschedule
      })
    },
    async cancelReschedule () {
      try {
        const customer_id = localStorage.getItem('customer_id')
        const payload = {
          schedule_date: this.$moment(
            this.eachEventInfo.extendedProps.course.schedule_date
          ).format('YYYY-MM-DD'),
          schedule_id: this.eachEventInfo.extendedProps.course.id,
          course_id: this.eachEventInfo.extendedProps.course.course_id,
          group_id: this.eachEventInfo.extendedProps.course.group_id
        }
        await cancelSchedulerApi(customer_id, payload)
        this.showSuccessMessage(
          'Success',
          'Lesson cancelled successfully',
          'success'
        )
      } catch (error) {
        console.warn(error)
        this.showSuccessMessage(
          'Error',
          'Something went wrong',
          'danger'
        )
      }
    },
    async attendanceAssign (type) {
      const payload = {
        course_id: this.eachEventInfo.extendedProps.course.course_id,
        schedule_id: this.eachEventInfo.extendedProps.course.id,
        attendance_date: this.eachEventInfo.extendedProps.course.schedule_date,

        clients:
          type === 'multiple'
            ? this.clientList.map((ele) => {
              return {
                attendance: ele.attendance,
                delay_in_minutes: ele.delay_in_minutes,
                client_user_id: ele.id
              }
            })
            : [
              {
                attendance: this.clientList.attendance,
                delay_in_minutes: this.clientList.delay_in_minutes,
                client_user_id:
                    this.eachEventInfo.extendedProps.course.client_user_id
              }
            ]

      }
      await markAttendence(this.customer_id, payload)
      this.showSuccessMessage(
        'Success',
        'Attendance marked successfully',
        'success'
      )
      this.active_el = null
      this.attendance_box = false
    },
    async fetchResheduleLog () {
      const payload = {
        group_id:this.eachEventInfo.extendedProps.course.group_id,
        course_id:this.eachEventInfo.extendedProps.course.course_id
      }
      const { data } = await fetchResheduleLog(this.customer_id, payload)
      this.reschedulesList = data.data.reschedules
      this.remainingReschedule = data.data.remaining_count
    },
    async fetchTimeByDate () {
      this.fetchTime(this)
    },
    fetchTime: _.debounce(async (vm) => {
      try {
        vm.fetchToChooseTime()
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async fetchToChooseTime () {
      try {
        this.$vs.loading()
        const payload = {
          course_start_date: this.schedule_start_date,
          course_id: this.eachEventInfo.extendedProps.course.course_id,
          start_time: this.eachEventInfo.extendedProps.course.schedule_from_time,
          end_time: this.eachEventInfo.extendedProps.course.schedule_to_time,
          teacher_id: [this.eachEventInfo.extendedProps.userId]
        }
        const { data } = await fetchResheduleSlot(this.customer_id, payload)

        this.availabilityTime = data.data.slots
        this.$vs.loading.close()

      } catch (e) {
        //
        this.$vs.loading.close()

      }

    }
  },
  directives: {
    'click-outside': {
      bind (el, binding) {
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          /* eslint-disable no-mixed-operators */
          if (bubble || !el.contains(e.target) && el !== e.target) {
          /* eslint-enable no-mixed-operators */
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler
        document.addEventListener('click', handler)
      },

      unbind (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null

      }
    }
  }
}
</script>
